import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence } from 'framer-motion';
import Text from '../../../../../General/Text';
import Button from '../../../../../General/Button';
import {
  ContainerStyled,
  HeaderStyled,
  HandleStyled,
  TextStyled,
  ContentStyled,
  CardIconsWrapperStyled,
  DisabledWebpayStyled,
} from './style/MethodStyled';
import { ReactComponent as ArrowNavIcon } from '../../../../../../images/ui/arrow-nav.svg';
import { ReactComponent as CardIcons } from '../../../../../../images/ui/payment-card-options.svg';
import { ReactComponent as WarningIcon } from '../../../../../../images/ui/balance-warning.svg';
import { GoogleTagManager, rechargeUrl } from '../../../../../../helpers';
import useModal from '../../../../../../hooks/useModal';
import useOtherLines from '../../../../../../hooks/useOtherLines';
import useDevice from '../../../../../../hooks/useDevice';
import { redirectInternalOrExternal } from '../../../../../../helpers/Redirect';
import { ModalStyled } from './style/ModalStyled';

const OtherMethodOfPay = ({ active, price }) => {
  const [toggled, setToggle] = useState(false);
  const { isShowing, toggle } = useModal();
  const { beneficiaryNumber } = useOtherLines();
  const { isSafari, isMobile } = useDevice();
  const lastNineDigits = beneficiaryNumber?.slice(-9);

  const rechargePortalUrl = rechargeUrl({
    linea: lastNineDigits,
    montorecarga: price,
    ver: 'mwm-3',
  });

  const handleIframeRender = () => {
    if (isSafari && isMobile) {
      redirectInternalOrExternal(rechargePortalUrl);
    } else toggle();
  };

  const clickHandler = () => {
    setToggle(!toggled);
  };

  const buyHandler = () => {
    handleIframeRender();
    GoogleTagManager.tagInteractiveEvent({
      eventCategory: 'Mis otras líneas',
      eventAction: 'Pago otros medios de pago',
      eventTag: 'BTN_COMPRAR_RECARGA_OTROS_MEDIOS',
    });
  };

  return (
    <ContainerStyled>
      <HeaderStyled>
        <TextStyled>
          <Text
            text="Otros medios de pago"
            color="#381451"
            size="18px"
            weight="500"
          />
        </TextStyled>
        <HandleStyled
          data-testid="toggle-handler"
          onClick={clickHandler}
          toggled={toggled}
        >
          <ArrowNavIcon />
        </HandleStyled>
      </HeaderStyled>
      <AnimatePresence initial={false}>
        {toggled && (
          <ContentStyled
            data-testid="toggle-content"
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.3 }}
          >
            {!active && (
              <DisabledWebpayStyled>
                <WarningIcon />
                <Text
                  text="Lo sentimos, el medio de pago no se encuentra disponible en estos momentos."
                  color="#E92070"
                  size="13px"
                  weight="400"
                />
              </DisabledWebpayStyled>
            )}
            <Button
              color="bubbleGum"
              maxWidth="100%"
              disabled={!active}
              click={buyHandler}
              margin={active ? '20px 0px' : '20px 0px 0px 0px'}
            >
              PAGAR
            </Button>
            <ModalStyled
              isShowing={isShowing}
              hide={toggle}
              className="custom-modal"
            >
              <iframe
                src={rechargePortalUrl}
                title="Recarga"
                sandbox="allow-same-origin allow-top-navigation allow-scripts allow-forms allow-downloads"
              />
            </ModalStyled>
            {active && (
              <CardIconsWrapperStyled>
                <CardIcons />
              </CardIconsWrapperStyled>
            )}
          </ContentStyled>
        )}
      </AnimatePresence>
    </ContainerStyled>
  );
};

OtherMethodOfPay.propTypes = {
  active: PropTypes.bool.isRequired,
  price: PropTypes.number.isRequired,
};

export default OtherMethodOfPay;
